export const API_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_backend_baseUrl_live
  : process.env.REACT_APP_backend_baseUrl_localTest;